import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=4b87abad&scoped=true"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"
import style0 from "./Checklist.vue?vue&type=style&index=0&id=4b87abad&prod&lang=scss&scoped=true"
import style1 from "./Checklist.vue?vue&type=style&index=1&id=4b87abad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87abad",
  null
  
)

export default component.exports